<template>
    <div class="h-100">
        <b-container class="p-0" fluid>
            <b-row align-h="center">
                <b-col md="10">
                    <b-link :to="{ name: 'secure-exports' }">
                        <font-awesome-icon icon="arrow-left" />
                        {{ $t("Back") }}
                    </b-link>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col md="10">
                    <h1 class="mb-2">{{ $t("secure-exports.title") }}</h1>
                </b-col>
            </b-row>

            <b-row align-h="start">
                <b-col md="1" sm="0"></b-col>
                <b-col lg="4">
                    <h4 class="mb-2">{{ $t("exports.contacts.description-title") }}</h4>
                    <p class="text-secondary font-small-3">
                        {{ $t("exports.contacts.description-text") }}
                    </p>
                    <br />
                    <b-button
                        :disabled="contactExportGenerating"
                        class="font-small-3 mb-50 mx-50"
                        variant="primary"
                        @click="startExport"
                        >{{ $t("secure-exports.generate.generate-csv-file") }}
                    </b-button>

                    <b-button
                        :disabled="!contactFileContent"
                        class="font-small-3 mb-50 mx-50"
                        variant="primary"
                        @click="downloadCsv(contactFileContent, `contact-export-${Date.now()}.csv`)"
                    >
                        {{ $t("secure-exports.download.download-csv-file") }}
                    </b-button>

                    <div v-if="contactExportGenerating" class="d-flex justify-content-center align-items-baseline mt-1">
                        <b-spinner
                            :label="$t('secure-exports.download.preparing')"
                            class="mr-50"
                            small
                            variant="primary"
                        />
                        <p class="text-left">{{ $t("secure-exports.download.preparing") }}</p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import useContactExports from "@/composables/useContactExports";
import ToastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import axios from "@/libs/axios";
import i18n from "@/libs/i18n";
import { downloadCsv } from "@/utils/download";
import { transformResponseMessageToErrorMessage } from "@/utils/exports";
import { BAlert, BButton, BCalendar, BCol, BContainer, BLink, BRow, BSpinner } from "bootstrap-vue";
import * as csv from "csv-stringify";
import { useToast } from "vue-toastification/composition";

export default {
    components: {
        BContainer,
        BCalendar,
        BButton,
        BSpinner,
        BRow,
        BCol,
        BAlert,
        BLink,
    },
    setup() {
        const toast = useToast();
        const { contactExportGenerating, contactFileContent } = useContactExports();

        const startExport = () => {
            contactExportGenerating.value = true;

            return axios
                .post("secure-exports/contacts")
                .then((result) => result.data)
                .then((csvData) => {
                    csv.stringify(
                        csvData.contacts,
                        {
                            delimiter: ";",
                            columns: csvData.columns,
                            header: true,
                        },
                        (error, csvAsString) => {
                            if (error) {
                                throw error;
                            }
                            contactFileContent.value = csvAsString;
                            contactExportGenerating.value = false;
                            toast({
                                component: ToastificationContent,
                                props: {
                                    title: i18n.t("exports.contacts.success-generating.title"),
                                    text: i18n.t("exports.contacts.success-generating.text"),
                                    icon: "check",
                                    variant: "success",
                                },
                            });
                        }
                    );
                })
                .catch((error) => {
                    contactExportGenerating.value = false;
                    contactFileContent.value = "";
                    notifyWithError(error.response ? error.response.data.message : error.message);
                });
        };

        const notifyWithError = (errorMessage) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: i18n.t("exports.error.title"),
                    text: i18n.t(transformResponseMessageToErrorMessage(errorMessage)),
                    icon: "times",
                    variant: "danger",
                },
            });
        };

        return {
            contactExportGenerating,
            contactFileContent,

            startExport,
            notifyWithError,
            downloadCsv,
        };
    },
};
</script>
